// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","faq-img":"Footer_faq-img__HB8ur","footer-text":"Footer_footer-text__9YKhF"};